/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState, createContext } from "react";
import { ScrollView, StatusBar, View } from "react-native";
import { useDispatch, useSelector } from "react-redux";
import Text from "@components/AppText";
import { actions } from "@reducers/cartReducer";
import { actions as configActions } from "@reducers/configReducer";
import { getTlUser, markCxFraud, getAllOrders } from "@services/api";
import { actions as customerActions } from "@reducers/customerReducer";
import OrdersListView from "@screens/OrdersList/View";
import Caret from "@assets/svg/Caret1";
import { CUSTOMER_PAGE } from "@constants/analyticsEventsCT";
import analytics from "@services/analytics";
import t from "@constants/localization";
import styles from "./styles";
import TopSection from "./TopSection";
import UserInfoCard from "./UserInfoCard";
import { verticalScale, scale } from "../../utils/scale";
import { LastTimeItem } from "./LastTimeItem";
import CartComponent from "./CartComponent";
import FetchCMSEntity from "../../components/CMS/FetchCMSEntity";
import ChartComponent from "../../components/CMS/ChartComponent";
import AllOrders from "../../assets/svg/AllOrders";
import FraudModal from "./FraudModal";

const PATH = "screens/CustomerProfile/index";

export const CustomerContext = createContext();

const CustomerProfile = (props) => {
  const { navigation, route } = props;
  const [user, setUser] = useState({
    ...route?.params?.user,
    user_id: route?.params?.user?.user_id || route?.params?.user_id,
  });
  const CMS_KEY = "CUSTOMER_DETAILS";
  const CX_CMS_ENTITY = "CX_PROFILE_CUSTOM";
  const [orders, setOrders] = useState([]);
  const [cartData, setCartData] = useState(undefined);
  const [isFetchingOrders, setIsFetchingOrders] = useState(true);
  const [canFetchOrders, setCanFetchOrders] = useState(true);
  const [isDeletedOrNotAddedCustomer, setDeletedOrNotAddedCustomer] =
    useState();
  const [salesData, setSalesData] = useState({
    labels: [],
    datasets: [
      {
        data: [],
      },
    ],
  });
  const { url } = useSelector((state) => state.auth.user);
  const cmsPoweredEntities = useSelector(
    (s) => s?.configReducer?.appSettings?.cmsPoweredEntities,
  );
  const cartShare = useSelector(
    (s) => s?.configReducer?.appSettings?.CL_CART_SHARE,
  );
  const offset = useRef(0);
  const limit = useRef(10);
  const totalOrders = useRef(0);
  const [lastLogin, setLastLogin] = useState("");
  const [lastOrder, setLastOrder] = useState("");
  const [totalOrder, setTotalOrder] = useState("");
  const [sales, setSales] = useState("");
  const [commission, setCommission] = useState("");
  const [address, setAddress] = useState("");
  const [fetched, setFetched] = useState(false);
  const [isloading, setIsLoading] = useState(true);
  const [isfraudCustomer, setIsfraudCustomer] = useState(false);
  const [showFraudModal, setShowFraudModal] = useState(false);
  const [fraudInfo, setFraudInfo] = useState({});
  const [fraudReason, setFraudReason] = useState("");
  const [fraudButtonLoading, setFraudButtonLoading] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    if (route.params && route.params.fetchProfile) {
      const { user_id = "" } = user;
      getTlUser(user_id)
        .then(({ data }) => {
          setUser(data.profileDetails);
          setLastLogin(data.profileDetails.last_login);
          setLastOrder(data.profileDetails.last_order_date);
          setCommission(data.profileDetails.total_commission);
          setTotalOrder(data.profileDetails.order_count);
          setSales(data.profileDetails.total_sale);
          setIsfraudCustomer(data.profileDetails.is_fraud_cx);
          setFraudInfo(data.meta.cx_fraud_info);
          setAddress(
            data.profileDetails.address
              ? data.profileDetails.address
              : t(`${PATH}/addressNotEntered`),
          );
          setCartData(data.cartdata);
          setFetched(true);
          if (data?.saleData) {
            setSalesData({
              labels: data?.saleData[0]?.type,
              datasets: [
                {
                  data: data?.saleData[0]?.total_sale,
                },
              ],
            });
          }

          dispatch(
            configActions.setHeaderTitle(
              data.user_name ? `${data.user_name}'s Profile` : "",
            ),
          );
          route.params = {};
          setIsLoading(false);
        })
        .catch((e) => {
          if (e?.response?.data?.error === "CX_NOT_CONNECTED") {
            setDeletedOrNotAddedCustomer(true);
          }
          if (!route?.params?.fromSalesReport) setUser(user);
          setIsLoading(false);
        });
    }
  }, [route]);

  const refresh = async () => {
    const { user_id = "" } = user;
    getTlUser(user_id)
      .then(({ data }) => {
        setUser(data.profileDetails);
        setLastLogin(data.profileDetails.last_login);
        setLastOrder(data.profileDetails.last_order_date);
        setCommission(data.profileDetails.total_commission);
        setTotalOrder(data.profileDetails.order_count);
        setSales(data.profileDetails.total_sale);
        setIsfraudCustomer(data.profileDetails.is_fraud_cx);
        setFraudInfo(data.meta.cx_fraud_info);
        setAddress(
          data.profileDetails.address
            ? data.profileDetails.address
            : t(`${PATH}/addressNotEntered`),
        );
        setCartData(data.cartdata);
        setFetched(true);
        if (data?.saleData) {
          setSalesData({
            labels: data?.saleData[0]?.type,
            datasets: [
              {
                data: data?.saleData[0]?.total_sale,
              },
            ],
          });
        }

        dispatch(
          configActions.setHeaderTitle(
            data.user_name ? `${data.user_name}'s Profile` : "",
          ),
        );
        route.params = {};
      })
      .catch((e) => {
        if (e?.response?.data?.error === "CX_NOT_CONNECTED") {
          setDeletedOrNotAddedCustomer(true);
        }
        if (!route?.params?.fromSalesReport) setUser(user);
      });
  };

  useEffect(() => {
    navigation.addListener("willFocus", () => {
      dispatch(
        configActions.setHeaderTitle(
          user?.user_name ? `${user?.user_name}'s Profile` : "",
        ),
      );
    });

    dispatch(
      configActions.setHeaderTitle(
        user?.user_name ? `${user?.user_name}'s Profile` : "",
      ),
    );

    // fetch user orders
    fetchCustomerOrders(true);
  }, []);

  const fetchCustomerOrders = (firstCall = false) => {
    // fetch user orders
    setCanFetchOrders(orders.length >= totalOrders.current);

    if (!firstCall && orders.length >= totalOrders.current) {
      return;
    }
    setIsFetchingOrders(true);

    if (Array.isArray(orders) && orders.length < totalOrders.current) {
      offset.current = firstCall
        ? offset.current
        : offset.current + limit.current;
    }
    const payload = {
      // pull: false,
      offset: offset.current,
      limit: limit.current,
      url,
      userId: user ? user.user_id : "",
    };

    getAllOrders(payload)
      .then(({ data }) => {
        setOrders(orders.concat(data.orders));
        setIsFetchingOrders(false);
      })
      .catch(() => {
        // console.log(e);
        setIsFetchingOrders(false);
      });
  };

  const handleReportFraud = async () => {
    setFraudButtonLoading(true);
    try {
      await markCxFraud({
        user_id: user?.user_id,
        reason: fraudReason,
      });
      setFraudButtonLoading(false);
      setShowFraudModal(false);
      refresh();
    } catch (e) {
      setFraudButtonLoading(false);
    }
  };

  const handleNewOrderClick = () => {
    dispatch(customerActions.setSelectedContact(user));
    dispatch(
      actions.viewCartLiteSuccess({ cartTotal: {}, result: [] }, user?.user_id),
    );
    dispatch(actions.viewCartLiteRequest(user));
    // dispatch(actions.setNewCustomerForOrderData(user));
    navigation.navigate("Home", { screen: "Home" });
    analytics.trackEvent(CUSTOMER_PAGE.CX_DETAIL_PLACE_ORDER, {
      cx_id: user?.user_id,
    });
  };

  // const allOrdersNew = orders;

  return (
    <View>
      <ScrollView showsVerticalScrollIndicator={false} style={styles.container}>
        <StatusBar barStyle="dark-content" />

        <View
          style={{
            height:
              address && address.length >= 100
                ? verticalScale(475)
                : address && address.length >= 70
                  ? verticalScale(415)
                  : verticalScale(395),
          }}
        >
          <TopSection address={address} user={user} />
          <UserInfoCard
            handleNewOrderClick={() => handleNewOrderClick()}
            navigation={navigation}
            user={user}
            address={address}
            fetched={fetched}
            isDeletedOrNotAddedCustomer={isDeletedOrNotAddedCustomer}
            isfraudCustomer={isfraudCustomer}
            setShowFraudModal={setShowFraudModal}
            isloading={isloading}
          />
        </View>
        <View
          style={{
            width: scale(330),
            alignSelf: "center",
            flexDirection: "row",
            justifyContent: "center",
          }}
        >
          <LastTimeItem
            description={lastLogin || "-"}
            title={t(`${PATH}/lastTimeAppOpened`)}
          />
          <LastTimeItem
            description={lastOrder || "-"}
            title={t(`${PATH}/lastTimeOrdered`)}
          />
        </View>

        {cmsPoweredEntities &&
        typeof cmsPoweredEntities === "object" &&
        CMS_KEY in cmsPoweredEntities ? (
          <View>
            <Text
              bold
              style={{
                fontSize: scale(16),
                marginTop: verticalScale(30),
                marginLeft: scale(15),
              }}
            >
              {t(`${PATH}/askYourCustomer`)}
            </Text>
            <CustomerContext.Provider
              value={{
                currentUser: user?.user_name,
                currentUserPhone: user?.user_phone,
                cx_id: user?.user_id,
              }}
            >
              <View>
                <FetchCMSEntity id={cmsPoweredEntities[CMS_KEY]} type="PAGE" />
              </View>
            </CustomerContext.Provider>
          </View>
        ) : null}

        <Text
          bold
          style={{
            fontSize: scale(16),
            marginTop: verticalScale(30),
            marginLeft: scale(15),
          }}
        >
          {t(`${PATH}/allOrderDetails`)}
        </Text>
        <View
          style={{
            width: scale(345),
            alignSelf: "center",
            marginTop: verticalScale(10),
            flexDirection: "row",
            justifyContent: "center",
          }}
        >
          <LastTimeItem
            containerStyle={{
              width: scale(104),
              marginHorizontal: scale(8),
              height: verticalScale(80),
            }}
            descriptionStyle={{ fontSize: scale(16) }}
            titleStyle={{ fontSize: scale(14) }}
            description={totalOrder || "-"}
            title={t(`${PATH}/totalOrders`)}
          />
          <LastTimeItem
            containerStyle={{
              width: scale(104),
              marginHorizontal: scale(8),
              height: verticalScale(80),
            }}
            descriptionStyle={{ fontSize: scale(16) }}
            titleStyle={{ fontSize: scale(14) }}
            description={sales || "-"}
            title={t(`${PATH}/sales`)}
          />
          <LastTimeItem
            containerStyle={{
              width: scale(104),
              marginHorizontal: scale(8),
              height: verticalScale(80),
            }}
            descriptionStyle={{ fontSize: scale(16) }}
            titleStyle={{ fontSize: scale(14) }}
            description={commission || "-"}
            title={t(`${PATH}/commission`)}
          />
        </View>
        <View>
          <View style={styles.ordersHeader}>
            <View style={{ paddingTop: 2 }}>
              <AllOrders />
            </View>
            <Text
              bold
              style={{
                flex: 1,
                fontFamily: "NotoSansDevanagari-Bold",
                marginLeft: 8,
                fontSize: scale(16),
              }}
            >
              {t(`${PATH}/totalOrders`)}
            </Text>
            {orders && orders.length > 1 && (
              <View style={{ flexDirection: "row" }}>
                <Text
                  onPress={() => {
                    navigation.navigate("UsersOrderList", {
                      user,
                      fetchProfile: true,
                      isProfileShow: true,
                    });
                    analytics.trackEvent(CUSTOMER_PAGE.CX_DETAIL_ALL_ORDERS, {
                      cx_id: user?.user_id,
                    });
                  }}
                  style={{
                    color: "#E40046",
                    fontFamily: "NotoSansDevanagari-Regular",
                    fontSize: scale(16),
                    LineHeight: 21,
                  }}
                >
                  {t(`${PATH}/seeAllOrders`)}
                </Text>
                <View style={{ marginTop: 7, marginLeft: 5 }}>
                  <Caret />
                </View>
              </View>
            )}
          </View>

          <OrdersListView
            horizontal={true}
            orders={orders}
            fetchCommunityLeaderOrders={fetchCustomerOrders}
            loading={isFetchingOrders}
            canFetchOrders={canFetchOrders}
            showUserName={false}
            showPhone={false}
            waText={t(`${PATH}/shareBill`)}
            // onScroll={onScroll}
            userId={user?.user_id}
          />
          {cmsPoweredEntities &&
          typeof cmsPoweredEntities === "object" &&
          CX_CMS_ENTITY in cmsPoweredEntities ? (
            <View>
              <FetchCMSEntity
                id={cmsPoweredEntities[CX_CMS_ENTITY]}
                type="PAGE"
              />
            </View>
          ) : null}

          {salesData &&
            salesData.datasets[0].data &&
            salesData.datasets[0].data.length !== 0 && (
              <Text
                bold
                style={{
                  fontSize: scale(16),
                  marginTop: verticalScale(30),
                  marginLeft: scale(15),
                }}
              >
                {t(`${PATH}/salesGraph`)}
              </Text>
            )}
          {salesData &&
            salesData.datasets[0].data &&
            salesData.datasets[0].data.length !== 0 && (
              <ChartComponent salesData={salesData} />
            )}
          {cartData && cartData.quantity !== 0 && (
            <CartComponent
              navigation={navigation}
              item={cartData}
              amount={cartData.cart_total}
              images={cartData.cart_images}
              name={user?.user_name}
              waText={false}
              num_items={`${cartData.items} ${t(`${PATH}/items`)} • ${
                cartData.quantity
              } ${t(`${PATH}/quantity`)}`}
              phone={user?.user_phone}
              cartShare={cartShare || ""}
            />
          )}
        </View>
      </ScrollView>
      <FraudModal
        showFraudModal={showFraudModal}
        setShowFraudModal={setShowFraudModal}
        fraudInfo={fraudInfo}
        fraudReason={fraudReason}
        setFraudReason={setFraudReason}
        isLoading={fraudButtonLoading}
        onPress={handleReportFraud}
      />
    </View>
  );
};

export default CustomerProfile;
